import { AppState } from '../../types';

export const selectCodeGeneration = (state: AppState) => state.phoneVerification.codeGeneration;
export const selectCodeVerification = (state: AppState) => state.phoneVerification.codeVerification;
